import script from "./RotaView.vue?vue&type=script&setup=true&lang=js"
export * from "./RotaView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__